export function hasReadPermission(config, permission) {
  return [1, true, 'read', 'edit'].includes(config[permission]);
}

export function hasEditPermission(config, permission) {
  return ['edit'].includes(config[permission]);
}

export function hasEditPermissionModuleSafe(config, permission) {
  return ['edit', true, 1].includes(config?.[permission]);
}

export function hasPermission(config, permission) {
  return [1, true, 'read', 'edit'].includes(config[permission]);
}

export function getHighestPermissionModule(permission, config1, config2) {
  const bool =
    hasPermission(config1, permission) || hasPermission(config2, permission);
  return bool;
}

export function getHighestPermissionFeature(permission, config1, config2) {
  if (
    hasEditPermission(config1, permission) ||
    hasEditPermission(config2, permission)
  ) {
    return 'edit';
  }
  if (
    hasReadPermission(config1, permission) ||
    hasReadPermission(config2, permission)
  ) {
    return 'read';
  }
  return 'off';
}

export function getHighestPermissionSubFeature(subFeature, config1, config2) {
  // For boolean sub-features, use OR logic (enabled if either config has it enabled)
  const config1Enabled = !!config1[subFeature];
  const config2Enabled = !!config2[subFeature];
  return config1Enabled || config2Enabled;
}

export function hasSubFeaturePermission(
  config,
  parentFeatureKey,
  subFeatureKey
) {
  // First check if parent feature is enabled
  const parentPermission = config[parentFeatureKey];
  if (!parentPermission || parentPermission === 'off') {
    return false; // Parent disabled, sub-feature doesn't matter
  }

  // Check if sub-feature is enabled (boolean)
  const subFeatureEnabled = config[subFeatureKey];
  if (!subFeatureEnabled) {
    return false; // Sub-feature disabled
  }

  // Sub-feature inherits parent's permission level
  return parentPermission; // Returns 'read' or 'edit'
}
